module.exports = __webpack_public_path__ + "static/media/pp_warning.aaa5da8a.svg";